import { BRAND } from "../data";

const COLS = [
  { title: "Company", links: ["About", "Products", "Sustainability", "Export"] },
  { title: "Resources", links: ["Blogs", "Contact", "Privacy Policy", "Terms & Conditions"] },
];

export default function Footer() {
  return (
    <footer data-testid="footer" className="bg-verra-blue text-white">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-20">
        <div className="grid lg:grid-cols-4 gap-12">
          <div className="lg:col-span-2">
            <span className="inline-block bg-white rounded-xl px-4 py-3">
              <img src={BRAND.logo} alt="Verraleaf" className="h-8 w-auto" />
            </span>
            <p className="mt-6 text-white/70 max-w-sm leading-relaxed">
              {BRAND.slogan}. Premium sustainable bagasse tableware by {BRAND.parent}.
            </p>
            <p className="mt-4 text-white/60 text-sm">{BRAND.email} · {BRAND.phone}</p>
            <p className="mt-2 text-white/50 text-sm max-w-xs">{BRAND.address}</p>
            <div className="mt-6 inline-flex items-center gap-3 rounded-xl bg-white/95 px-4 py-3 w-fit">
              <img src={BRAND.parentLogo} alt={BRAND.parent} className="h-14 w-auto" />
            </div>
          </div>
          {COLS.map((c) => (
            <div key={c.title}>
              <p className="overline text-verra-light mb-5">{c.title}</p>
              <ul className="space-y-3">
                {c.links.map((l) => (
                  <li key={l}>
                    <a href="#top" className="text-white/70 hover:text-verra-light transition-colors text-sm">{l}</a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between gap-4 text-sm text-white/50">
          <p>© {new Date().getFullYear()} {BRAND.parent}. All rights reserved.</p>
          <p>Brand: {BRAND.name} · {BRAND.website}</p>
        </div>
      </div>
    </footer>
  );
}
